import { Colors } from '../consts/Colors.js';
import FONTS from '../consts/Fonts.js';
import ButtonMenu from '../prefabs/global/buttons/ButtonMenu.js';
import ButtonRounded from '../prefabs/global/buttons/ButtonRounded.js';
import LoginPanel from '../prefabs/menu/LoginPanel.js';
import NewGamePanel from '../prefabs/menu/NewGamePanel.js';
import SauvegardeManager from '../prefabs/SauvegardeManager.js';
import SoundManager from '../prefabs/SoundManager.js';
import AbstractScene from './AbstractScene.js';


export default class Fin extends AbstractScene {
    constructor() {
        super({
            key: "Fin"
        })
    }
    init(data) {
        this._init(data);

        this.sauvegardeManager = new SauvegardeManager()
    }

    preload() {
        this._preload();

        this.menuGroup = this.add.group();

        this.soundManager = new SoundManager();
        this.soundManager.stopAllLoops()
        this.soundManager.playAudio('Intro');
    }

    create(){
        // Ajout du fond
        this.background = this.add.image(-229, -157, 'menu_background').setOrigin(0, 0);

        // Ajout du titre   
        let titre = this.add.image(91, 819, 'menu_titre').setOrigin(0).setScale(0.5)
        this.menuGroup.add(titre)

        // Ajout du panneau de fin
        this.finPanel = this.add.container(this.width, 0, []);

        let backPanel = this.add.rectangle(0, 0, 1280, this.height, Colors.Elmt.DarkBlue).setOrigin(0);
        backPanel.setStrokeStyle(2, Colors.Elmt.White, 0.75)
        this.finPanel.add(backPanel);

        let rectOrange = this.add.rectangle(0, backPanel.height, backPanel.width, 340, Colors.Elmt.Orange).setOrigin(0, 1);
        rectOrange.setStrokeStyle(2, Colors.Elmt.White, 0.75)
        this.finPanel.add(rectOrange);

        let T = "Vous avez retrouvé la docteure Cercis, retenue prisonnière par Kensei Therapeutics afin d’exploiter sa crédibilité dans une vaste escroquerie médicale. Leur objectif : faire croire qu’une plante possédait des propriétés curatives exceptionnelles en s’appuyant sur des fake news, des fausses preuves et des contenus générés par IA pour appuyer leurs propos.\n"
                    +"Votre détermination et votre esprit d’enquêteur ont eu raison de leurs manigances ! Leïla et sa sœur vous sont reconnaissantes, tout comme les nombreuses personnes qui auraient pu être trompées par ces fausses promesses !"
        let finText = this.add.text(80, 74, T, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '28px',
            color: Colors.Text.White,
            wordWrap: { width: 1120 },
        }).setOrigin(0)
        this.finPanel.add(finText);

        let logoCVC = this.add.image(110, 460, 'logo_CVC').setOrigin(0).setScale(0.7);
        this.finPanel.add(logoCVC);

        let textRessources = this.add.text(754, 504, "Retrouvez ici une sélection des meilleurs outils pour décrypter et débusquer les fake news.", {
            fontFamily: FONTS.Inter28BoldItalic,
            fontSize: '28px',
            color: Colors.Text.White,
            wordWrap: { width: 426 },
            align: 'right'
        }).setOrigin(1, 0)
        this.finPanel.add(textRessources);

        let buttonRessources = new ButtonRounded(this, 990, textRessources.y + textRessources.height/2, {
            text: "Découvrir les ressources",
            color: Colors.Elmt.White,
            hoverColor: Colors.Elmt.DarkBlue,
            textColor: Colors.Text.DarkBlue,
            textHoverColor: Colors.Text.White,
            borderColor: Colors.Elmt.White,
        })
        this.finPanel.add(buttonRessources);

        let titreThanks = this.add.text(80, backPanel.height - rectOrange.height + 55, "Merci d'avoir joué à notre jeu !", {
            fontFamily: FONTS.Inter28ExtraBold,
            fontSize: '40px',
            color: Colors.Text.Black,
        }).setOrigin(0)
        this.finPanel.add(titreThanks);

        let textThanks = this.add.text(80, titreThanks.y + titreThanks.height + 24, "N’hésitez pas à en parler autour de vous : plus nous sommes nombreux à développer notre esprit critique, plus nous sommes armés face à la désinformation. À très bientôt !", {
            fontFamily: FONTS.Inter28SemiBold,
            fontSize: '28px',
            color: Colors.Text.White,
            wordWrap: { width: 1120 },
        }).setOrigin(0)
        this.finPanel.add(textThanks);

        let menuButton = new ButtonRounded(this, rectOrange.width/2, textThanks.y + textThanks.height + 40, {
            text: "Menu principal",
            color: Colors.Elmt.White,
            hoverColor: Colors.Elmt.DarkBlue,
            textColor: Colors.Text.DarkBlue,
            textHoverColor: Colors.Text.White,
        })
        menuButton.y += menuButton.height/2
        this.finPanel.add(menuButton);
        menuButton.setClickFunction( () => {
            let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.DarkBlue).setOrigin(0).setAlpha(0).setDepth(10);
            this.tweens.add({
                targets: rect,
                alpha: 1,
                duration: 500,
            })
            this.tweens.add({
                targets: this.finPanel,
                x: this.width,
                duration: 500,
                ease: 'Cubic.easeInOut',
                onComplete: () => {
                    this.scene.start("Menu");
                }
            })
        })

        this.finPanel.setSize(backPanel.width, backPanel.height)

        this.tweens.add({
            targets: this.finPanel,
            x: this.width - this.finPanel.width,
            duration: 500,
            ease: 'Cubic.easeInOut',
        })
    }
}